import React from "react";
import { createContext } from "react";
// * React router dom stuff
import { Switch, Route, useLocation } from "react-router-dom";
import { routes } from "routes/Dashboard";
// * Components
import {
  Loader,
  ScrollToTop,
  SidebarDashboard,
  TertiaryButton,
} from "components";
import {
  LoaderContainerDashboard,
  ParagraphLink,
  ParagraphTextColor,
} from "utils";
import "./styles.scss";
import { DashboardNavbar } from "components/Dashboard";
// * Socket
import { w3cwebsocket as W3CWebSocket } from "websocket";
// * RRD
import { useHistory } from "react-router-dom";
import toast from "react-hot-toast";
import { themed } from "components";
export const SocketContext = createContext();
const { role, id } = JSON.parse(localStorage.getItem("userInfo")) || {};
var socket = null;
if (localStorage.getItem("userInfo") !== null) {
  socket = new W3CWebSocket(`${process.env.REACT_APP_SOCKET_URL}/${id}`);
}
export const DashboardRouter = () => {
  const history = useHistory();
  const { pathname } = useLocation();

  React.useEffect(() => {
    const dashboardContent = document.getElementById("dashboard__content");
    if (dashboardContent) {
      // get the first child of the dashboard content
      if (dashboardContent.firstElementChild) {
        dashboardContent.firstElementChild.scrollIntoView();
      }
    }
    if (localStorage.getItem("userInfo") === null) {
      history.push("/login");
      toast.error("Inicia sesión para acceder a la plataforma", { ...themed });
    }
  }, [pathname, history]);
  React.useEffect(() => {
    if (socket) {
      socket.onmessage = (e) => {
        toast(
          (t) => (
            <div>
              <ParagraphTextColor>
                Tienes una nueva notificación
              </ParagraphTextColor>
              <span
                modifiers={["small"]}
                onClick={() => {
                  history.push(`/dashboard/notificaciones`);
                  toast.dismiss(t.id);
                }}
              >
                Ver
              </span>
            </div>
          ),
          { ...themed }
        );
      };
    }
  }, []);
  return (
    <div className="dashboard__router">
      <SocketContext.Provider
        value={{
          socket: socket,
        }}
      >
        <SidebarDashboard />
        <ScrollToTop />
        <React.Suspense
          fallback={
            <LoaderContainerDashboard id="loader__dashboard">
              <Loader />
            </LoaderContainerDashboard>
          }
        >
          <div className="dashboard__content">
            <DashboardNavbar />
            <div id="dashboard__content">
              <Switch>
                {role === "sucursalWorker"
                  ? routes
                      .filter((route) => route.onlyAdmin === false)
                      .map((route, index) => (
                        <Route
                          key={index}
                          path={route.path}
                          exact={route.exact}
                          render={(props) => <route.component {...props} />}
                        />
                      ))
                  : routes.map((route, index) => (
                      <Route
                        key={index}
                        path={route.path}
                        exact={route.exact}
                        render={(props) => <route.component {...props} />}
                      />
                    ))}
              </Switch>
            </div>
          </div>
        </React.Suspense>
      </SocketContext.Provider>
    </div>
  );
};
